<template>
  <v-row justify="center">
    <v-dialog
      v-model="open"
      width="800px"
      @click:outside="handleClose"
      @keydown="handleEvent"
    >
      <v-card>
        <v-toolbar elevation="0" class="mb-4">
          <v-icon
            @click="backStep"
            class="close-icon"
            size="24"
            color="grey"
            style="cursor: pointer"
          >
            mdi-arrow-left
          </v-icon>
          <v-toolbar-title>{{ $t('message.importVideos') }}</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-btn icon @click="handleClose()" class="mr-2">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <dashboard
            v-if="open"
            :uppy="uppyConfig"
            :props="dashboardProps"
          ></dashboard>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { Dashboard } from '@uppy/vue'
import '@uppy/core/dist/style.css'
import '@uppy/dashboard/dist/style.css'

export default {
  name: 'ImportModal',
  components: {
    Dashboard,
  },
  props: {
    uppyConfig: {},
  },
  data: () => ({
    open: false,
    dashboardProps: {
      inline: true,
      locale: 'pt_BR',
      height: 470,
      proudlyDisplayPoweredByUppy: false,
    },
  }),
  mounted() {
    this.$root.$on('openImportVideoModal', () => {
      this.open = true
    })
    this.$root.$on('importUploadError', () => {
      this.handleClose()
    })
  },
  beforeDestroy() {
    this.$root.$off('importUploadError')
  },
  methods: {
    backStep() {
      this.open = false
    },
    handleClose() {
      this.open = false
      this.$root.$emit('importModal', { open: false })
      this.$root.$emit('resetIsAnyOtherModal')
      this.$root.$emit('close-modal')
    },
    handleEvent(event) {
      const e = event
      if (e.key) {
        e.key === 'Escape' && this.handleClose()
      }
      return
    },
  },
}
</script>

<style>
button[aria-controls='uppy-DashboardContent-panel--Vimeo'] > svg {
  visibility: hidden !important;
}

/* button[aria-controls='uppy-DashboardContent-panel--Vimeo']::before {
  content: url('@/assets/vimeoIcon.png');
} */

.uppy-DashboardContent-panelBody .uppy-Url .uppy-c-textInput {
  width: 380px !important;
}

.uppy-DashboardContent-panelBody .uppy-Url .uppy-c-btn {
  margin: 10px auto 0;
  display: table;
}
</style>
